import {StyledMegalogo} from './Megalogo.styled';
import {IconButton} from '../';
import { AppContext } from '../../providers/AppContext';
import { useContext } from 'react';
import {
  useNavigate,
} from "react-router-dom";
import { useAccount } from 'wagmi';
import useIsMobile from '../../hooks/useIsMobile';

const Megalogo = ({ onlyMid = false }) => {
  const { setShowLogin, setShowDesktopOnly } = useContext(AppContext);
  const navigate = useNavigate();
  const { isConnected } = useAccount();
  const isMobile = useIsMobile();

  const onClick = () => {
    isConnected ? navigate('/app') : isMobile ? setShowDesktopOnly(true) : setShowLogin(true);
  };

  return (
    <StyledMegalogo>
      <img className='megalogo-mid' src='/assets/low-respng.png' />
      {!onlyMid && <>
        <div className='megalogo-button-container'>
          <IconButton
            animated={true}
            onClick={onClick}>
            <div className='megalogo-button-content'>
              <img style={{paddingBottom: '6px'}} src='/assets/try_left.svg'/>
              <div>Get Yours Now</div>
              <img style={{paddingBottom: '6px'}} src='/assets/try_right.svg'/>
            </div>
          </IconButton>
        </div>
        <img className='megalogo-bottom' src='/assets/megalogo_bottom.svg' />
      </>}
    </StyledMegalogo>
  );  
};

export default Megalogo;
